// Standard integrals reference table — common antiderivatives.
// LaTeX strings rendered with KaTeX in the integral calculator.

export interface StandardIntegral {
  fTex: string;
  FTex: string;
}

export const STANDARD_INTEGRALS: StandardIntegral[] = [
  { fTex: "k", FTex: "kx" },
  { fTex: "x^n", FTex: "\\dfrac{x^{n+1}}{n+1}" },
  { fTex: "\\dfrac{1}{x}", FTex: "\\ln|x|" },
  { fTex: "e^x", FTex: "e^x" },
  { fTex: "a^x", FTex: "\\dfrac{a^x}{\\ln a}" },
  { fTex: "\\sin x", FTex: "-\\cos x" },
  { fTex: "\\cos x", FTex: "\\sin x" },
  { fTex: "\\tan x", FTex: "-\\ln|\\cos x|" },
  { fTex: "\\cot x", FTex: "\\ln|\\sin x|" },
  { fTex: "\\sec x", FTex: "\\ln|\\sec x + \\tan x|" },
  { fTex: "\\csc x", FTex: "-\\ln|\\csc x + \\cot x|" },
  { fTex: "\\sec^2 x", FTex: "\\tan x" },
  { fTex: "\\csc^2 x", FTex: "-\\cot x" },
  { fTex: "\\sec x \\tan x", FTex: "\\sec x" },
  { fTex: "\\csc x \\cot x", FTex: "-\\csc x" },
  { fTex: "\\dfrac{1}{\\sqrt{1-x^2}}", FTex: "\\arcsin x" },
  { fTex: "\\dfrac{1}{1+x^2}", FTex: "\\arctan x" },
  { fTex: "\\dfrac{1}{x\\sqrt{x^2-1}}", FTex: "\\operatorname{arcsec}|x|" },
  { fTex: "\\sinh x", FTex: "\\cosh x" },
  { fTex: "\\cosh x", FTex: "\\sinh x" },
  { fTex: "\\ln x", FTex: "x\\ln x - x" },
];
